<template>
  <div class="collection">
    <div class="fr"><Bread :prop="bread" /></div>
    <div class="container fl" id="container">
      <div class="cartContent">
        <div class="content">
          <el-row class="demo-autocomplete">
              <el-col :span="12">
                  <el-autocomplete
                  style="width: 475px;border-raiuds: 0;height: 32px;"
                  class="inline-input"
                  v-model="state2"
                  :fetch-suggestions="querySearch"
                  :placeholder="'输入商品名称或者订单号查询'"
                  :trigger-on-focus="false"
                  @select="handleSelect"
                  >
                  </el-autocomplete>
              </el-col>
          </el-row>
          <div class="serarchButton" @click="search()"></div>
          <BasicTable 
                :tableData="tableData" 
                :columns="columns" 
                style="height:98%;margin:30px 0;"
                :pageSize="pageQuery.page_size"
                :current-page="pageQuery.page"
                @pageChange="pageChange"
                :total="pageQuery.total">
                 <template v-slot:goods_name="{ item }">
                   <img class="goodsImg" :src="item.original_img" />
                    {{ item.goods_name }}
                  </template>
                  <template v-slot:operate="{ item }">
                    <span class="operate" @click="delectCollect(item)">删除</span>
                    <span class="operate" @click="toGoods(item)" style="margin-left:5px;">查看</span>
                  </template>
          </BasicTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bread from '@/components/Bread/index.vue'
import { UserCenterService } from '../../../service/userCenter.service'
import { GoodsService } from '../../../service/goods.service'
import { Loading } from 'element-ui'
import { MessageBox } from 'element-ui';

const columns = [
  { name: '商品名称', key: 'goods_name',type: 'custom' },
  { name: '规格', key: 'goods_spec' },
  { name: '通用名',key: 'common_name' },
  { name: '创建时间', key: 'add_time'},
  { name: '操作', key: 'operate', type: 'custom' },
];
  export default {
    name: 'collection',
    components: { Bread },
    data() {
      return{
        tableData:[],
        columns,
        pageQuery:{
          page: 1,
          total: 0,
          page_size:20
        },
        bread: [{
            name: '用户中心',
            path: '/userCenter/index'
        },{
            name: '我的收藏',
            path: '/userCenter/collection'
        }],
        state2: ''
      }
    },
    methods: {
      handleSelect(item) {
          console.log(item)
      },
      querySearch(queryString, cb) {
          var commdity = this.commdity;
          var results = queryString ? commdity.filter(this.createFilter(queryString)) : commdity;
          // 调用 callback 返回建议列表的数据
          cb(results);
      },
      async getList() {
          const data = await UserCenterService.collectList(this.pageQuery)
          this.tableData = JSON.parse(JSON.stringify(data.list))
          this.pageQuery.total = data.totalRow
      },
      async pageChange(index) {
          const defaultIndex = this.pageQuery.page
          this.pageQuery.page = index
          try{
            const data = await UserCenterService.collectList(this.pageQuery);
            this.tableData = JSON.parse(JSON.stringify(data.list))
          }catch(e) {
            console.log(defaultIndex)
            this.pageQuery.page = defaultIndex
          }
          
      },
      toGoods(val) {
        this.$router.push(`/goodDetail/${val.goods_id}`);
      },
      async delectCollect(val) {
        await MessageBox.confirm('确定删除该收藏吗？');

        try{
          await GoodsService.removeCollect(val.collect_id)
          let loadingInstance = Loading.service();
          this.getList()
          this.$nextTick(() => {
            loadingInstance.close();
          });
        }catch(e){
          console.log(e)
        }
      },
      search() {
      },
      loadAll() {
          return [
              { "value": "三全鲜食（北新泾店）"},
              { "value": "Hot honey 首尔炸鸡（仙霞路）"},
          ]
      }
    },
    mounted() {
      this.getList()
    }
  }
</script>

<style lang="scss" scoped>
.collection {
  width: 935px;
  .content{
    height: 500px;
  }
  .cartContent{
    .bottom{
      margin: 0;
    }
  }
  .goodsImg{
    width: 80px;
    height: 80px;
    object-fit: contain;
    vertical-align: middle;
  }
  .operate{
    cursor: pointer;
  }
  .operate:hover{
    color: #e4221c;
    text-decoration: underline;
  }
}

.container {
  padding: 0px 20px 10px;
  display: flex;
  justify-content: center;
  border: 1px solid #e3e2e1
}

.cartContent {
  position: relative;
  display: flex;
  flex-direction: column;
  .top {
    display: flex;
    justify-content: space-between;

  }
  .content {
    width: 935px;
    display: flex;
    flex-direction: column;
    .drugItem {
      border-top: none;
    }
  }
  .bottom {
    margin: 0 16px;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #e5e5e5;
    height: 38px;
    padding-left: 20px;
    .right {
      border: none;
      padding: 0;
      .submitBtn {
        height: 38px;
        width: 80px;
      }
    }
    .left > div {
      border: none;
      padding: 0;
    }
    .bottomLeft {
      font-weight: 300;
      font-size: 15px;
    }
  }
}

.amount {
  color: red;
  font-weight: 600;
}

.left {
  font-size: 18px;
  font-weight: 600;
  display: flex;
  .allgoods {
    
  }
  .delimiter {
    padding: 0 10px;
  }
  & > div {
    padding-bottom: 20px;
    border-bottom: 2px solid #bab9b9;
  }
}
.right {
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
  border-bottom: 2px solid #bab9b9;
  padding-bottom: 20px;
}
.submitBtn {
  border-radius: 0 !important;
  height: 25px;
  width: 46px;
  margin-left: 10px !important;
  padding: 0 !important;
  font-size: 12px;
}

.tableTitle {
  margin-top: 8px;
  color: #999;
  font-size: 13px;
  display: flex;
  padding: 8px 0;
  border: 1px solid #babab9;
  .th-chk{
    margin-left: 23px;
    width: 144px;
  }
  .th-info{
    width: 276px;
    display: flex;
    justify-content: center;
  }
  .th-price{
    width: 126px;
    display: flex;
    justify-content: center;
  }
  .th-amount{
    width: 207px;
  }
  .th-company{
    width: 287px;
    display: flex;
    justify-content: center;
  }
  .th-op{
    width: 77px;
    display: flex;
    justify-content: center;
  }
}
.drugItem {
  height: 110px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #babab9;
  & > div {
    display: flex;
    align-items: center;
    justify-content: left;
  }
  .drugImg {
    height: 55px;
    width: 88px;
  }
  .td-item{
    width: 144px;
    margin-left: 23px;
  }
  .td-info{
    display: flex;
    flex-direction: column;
    width: 276px;
    justify-content: center;
  }
  .td-company{
      width: 287px;
      justify-content:center;
  }
  .td-price{
      width: 126px;
      display: flex;
      justify-content: center;
  }
  .td-sum{
    width: 154px;
  }
  .td-op{
    display: flex;
    flex-direction: row;
    cursor: pointer;
    width: 77px;
    justify-content: center;
  }
  .td-op>div:hover{
    color: rgb(46, 152, 213);
  }
}
#float-bar {
  position: fixed;
  width: 930px;
  bottom: 0;
  z-index: 5;
}
.demo-autocomplete.el-row{
  margin: 15px 0;
  position: relative;
  left: 0;
}
.serarchButton{
  position: absolute;
  width: 70px;
  height: 35px;
  background: url('../../../assets/images/icon/searchIcon.png') center center no-repeat #1d90d0;
  left: 420px;
  top: 15px;
  cursor: pointer;
}
</style>
